<template>
  <ul class="info-lines">
    <li v-for="(slug, index) in info_slugs_final" :key="index">
      <div
        v-if="slug == 'timings_in_timezone' && timezone"
        v-html="
          Tsprintf(
            /* translators: 1: html-tag-open 2: html-tag-close 3: timezone */
            T__(
              'All timings in this page are in %1$s %3$s %2$s Time Zone as per Event Type settings.'
            ),
            '<span style=&quot;font-weight:500&quot;>',
            '</span>',
            timezone
          )
        "
      ></div>
      <!-- <div
        v-else-if="slug == 'setup_other_admins'"
        v-html="
          Tsprintf(
            /* translators: 1: html-tag-open 2: html-tag-close 3: timezone */
            T__(
              'Want to set up/view/edit other admins\' event types or bookings? %1$s Read this &nearr; %2$s.'
            ),
            '<a href=&quot;https://help.wpcal.io/en/article/how-to-editviewithsetup-other-admins-event-types-or-bookings-nj0zjk/&quot; target=&quot;_blank&quot; >',
            '</a>'
          )
        "
      ></div> -->
      <div v-else-if="get_info_by_slug(slug)">
        {{ get_info_by_slug(slug) }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "AdminInfoLine",
  props: {
    info_slugs: {
      type: Array
    },
    info_slug: {
      type: String
    },
    timezone: {
      type: String
    }
  },
  data() {
    return {
      admin_info_list: {
        ownership_settings_general: this.T__(
          "These settings are common for and apply to all admins."
        ),
        ownership_settings_profile: this.T__(
          "This is used only for your event types and bookings. Each admin will have their own profile in their login."
        ),
        ownership_settings_calendars: this.T__(
          " These calendar accounts are visible only to you and used only for your event types and bookings. Each admin will connect and use their own calendar accounts in their login."
        ),
        ownership_settings_integrations: this.T__(
          "These integration accounts are visible only to you and used only for your event types and bookings. Each admin will connect and use their own integration accounts in their login."
        ),
        // ownership_single_event_type: this.T__(
        //   "This event type can be managed only by you."
        // ),
        // ownership_my_bookings: this.T__("Only your bookings are listed here."),

        booking_default_reminder_email: this.T__(
          "A reminder email will be sent to invitees 24hrs before their scheduled event time."
        ),
        conflict_resolution_for_host: this.T__(
          "Time slots booked for an event type will be removed for other event types' availability for the same host to avoid double booking."
        ),
        wpcal_admin_feature_access_info: this.T__(
          "WPCal Admin features are available to WPCal admins only."
        )
      }
    };
  },
  computed: {
    info_slugs_final() {
      let info_slugs_tmp = [];
      if (Array.isArray(this.info_slugs) && this.info_slugs.length) {
        info_slugs_tmp = this.clone_deep(this.info_slugs);
      } else if (this.info_slug) {
        info_slugs_tmp = [this.info_slug];
      }
      return info_slugs_tmp;
    }
  },
  methods: {
    get_info_by_slug(slug) {
      if (!this.admin_info_list.hasOwnProperty(slug)) {
        return "";
      }
      return this.admin_info_list[slug];
    }
  }
};
</script>
